export default {
  APP_TOKEN: 'a998024e3d3991c2bbde0583b7246fafe14e2a32',
  CLIENT_ID: '05324f99508c497daa74d67cec5e6bf7',
};



// WEBPACK FOOTER //
// ./env/prod-config.js